/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  OktaServerSuggestionRemoteHeader,
  OktaServerSuggestionRemoteHeader$inboundSchema,
} from "./oktaserversuggestionremoteheader.js";

/**
 * One remote endpoint of the suggested server, as the catalog entry lists it. The administrator picks one when there are several.
 */
export type OktaServerSuggestionRemote = {
  /**
   * Headers the endpoint expects, in catalog order.
   */
  headers: Array<OktaServerSuggestionRemoteHeader>;
  /**
   * Transport type, for example streamable-http.
   */
  type: string;
  /**
   * Endpoint URL to create the remote MCP server with.
   */
  url: string;
};

/** @internal */
export const OktaServerSuggestionRemote$inboundSchema: z.ZodMiniType<
  OktaServerSuggestionRemote,
  unknown
> = z.object({
  headers: z.array(OktaServerSuggestionRemoteHeader$inboundSchema),
  type: z.string(),
  url: z.string(),
});

export function oktaServerSuggestionRemoteFromJSON(
  jsonString: string,
): SafeParseResult<OktaServerSuggestionRemote, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => OktaServerSuggestionRemote$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'OktaServerSuggestionRemote' from JSON`,
  );
}
